module.exports = __webpack_public_path__ + "img/1721784409636-WhatsApp Image 2024-07-24 at 09.24.57.jpeg.5feb59bc.webp";